export enum MaintenanceTicketJournalForms {
  Create = 'CreateMaintenanceTicketJournalForms',
}
